import moment from "moment";

export const TIME_OPTIONS = [
  "Today",
  "Yesterday",
  "Last 7 days",
  "Last 30 days",
  "Custom time",
];

export function isValidDateRange(range) {
  return (
    moment(range.from, "YYYY-MM-DD", true).isValid() &&
    moment(range.to, "YYYY-MM-DD", true).isValid() &&
    range.from <= range.to
  );
}

export function getDateRange(preset, now = moment()) {
  const to = moment(now);
  if (preset === "Yesterday") to.subtract(1, "day");
  const from = to.clone();
  if (preset === "Last 7 days") from.subtract(6, "days");
  if (preset === "Last 30 days") from.subtract(29, "days");
  return { from: from.format("YYYY-MM-DD"), to: to.format("YYYY-MM-DD") };
}
